import { render, staticRenderFns } from "./TestTable.vue?vue&type=template&id=f09ce510&scoped=true"
import script from "./TestTable.vue?vue&type=script&lang=js"
export * from "./TestTable.vue?vue&type=script&lang=js"
import style0 from "./TestTable.vue?vue&type=style&index=0&id=f09ce510&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09ce510",
  null
  
)

export default component.exports